export const CHAT_LOCAL_STORAGE_KEY = "arthur-chat-state";
export const LOADER_LOCAL_STORAGE_KEY = "arthur-loader-state";
